module.exports = __webpack_public_path__ + "img/face2.19cfa0cd.png";